import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "tree-panel",
  class: "base-tree-panel uk-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_items_tree = _resolveComponent("items-tree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_items_tree, {
      type: _ctx.type,
      loading: _ctx.loading,
      onItemClicked: _ctx.itemClickedHandler,
      onPaginate: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('paginate')))
    }, null, 8, ["type", "loading", "onItemClicked"])
  ]))
}